(function(){
  "use strict";
  function setup(tablist){
    if(!tablist) return;
    var alreadyReady=tablist.getAttribute("data-pfi-tabs-ready")==="true";
    var tabs=Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"][data-tab-mb-item]'));
    if(tabs.length<2) return;
    var panels=tabs.map(function(tab){return document.getElementById(tab.getAttribute("aria-controls"));});
    function activate(tab,moveFocus){
      var index=tabs.indexOf(tab);
      if(index<0||!panels[index]) return;
      tabs.forEach(function(item,itemIndex){
        var selected=itemIndex===index;
        item.classList.toggle("is--active",selected);
        item.setAttribute("aria-selected",selected?"true":"false");
        item.tabIndex=selected?0:-1;
        if(panels[itemIndex]){
          panels[itemIndex].classList.toggle("is--active",selected);
          panels[itemIndex].hidden=!selected;
          panels[itemIndex].setAttribute("aria-hidden",selected?"false":"true");
        }
      });
      if(moveFocus) tab.focus();
    }
    function currentTab(){
      return tabs.find(function(tab){return tab.classList.contains("is--active")||tab.getAttribute("aria-selected")==="true";})||tabs[0];
    }
    function firstPanelControl(index){
      var panel=panels[index];
      if(!panel) return null;
      return panel.querySelector('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
    }
    if(tablist.getAttribute("data-pfi-tab-exit-ready")!=="true"){
      tablist.addEventListener("keydown",function(event){
        var tab=event.target.closest('[role="tab"][data-tab-mb-item]');
        if(!tab||event.key!=="Tab"||event.shiftKey) return;
        var firstControl=firstPanelControl(tabs.indexOf(tab));
        if(firstControl){event.preventDefault();firstControl.focus();}
      });
      panels.forEach(function(panel,index){
        if(!panel) return;
        panel.addEventListener("keydown",function(event){
          if(!event.shiftKey||event.key!=="Tab") return;
          var firstControl=firstPanelControl(index);
          if(event.target!==firstControl) return;
          event.preventDefault();
          tabs[index].focus();
        });
      });
      tablist.setAttribute("data-pfi-tab-exit-ready","true");
    }
    if(alreadyReady) return;
    tablist.addEventListener("click",function(event){
      var tab=event.target.closest('[role="tab"][data-tab-mb-item]');
      if(!tab||!tablist.contains(tab)) return;
      activate(tab,false);
      requestAnimationFrame(function(){activate(tab,false);});
    });
    tablist.addEventListener("keydown",function(event){
      var tab=event.target.closest('[role="tab"][data-tab-mb-item]');
      if(!tab) return;
      var index=tabs.indexOf(tab);
      var nextIndex=index;
      if(event.key==="ArrowRight") nextIndex=(index+1)%tabs.length;
      else if(event.key==="ArrowLeft") nextIndex=(index-1+tabs.length)%tabs.length;
      else if(event.key==="Home") nextIndex=0;
      else if(event.key==="End") nextIndex=tabs.length-1;
      else return;
      event.preventDefault();
      activate(tabs[nextIndex],true);
    });
    var queued=false;
    new MutationObserver(function(records){
      if(queued||!records.some(function(record){return record.attributeName==="class";})) return;
      queued=true;
      requestAnimationFrame(function(){queued=false;activate(currentTab(),false);});
    }).observe(tablist,{attributes:true,attributeFilter:["class"],subtree:true});
    tablist.setAttribute("data-pfi-tabs-ready","true");
    activate(currentTab(),false);
  }
  function init(scope){(scope||document).querySelectorAll('[data-tab-mb-nav][role="tablist"]').forEach(setup);}
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",function(){init(document);},{once:true}); else init(document);
  document.addEventListener("shopify:section:load",function(event){init(event.target);});
  var pfiBootQueued=false;
  new MutationObserver(function(records){
    if(pfiBootQueued||!records.some(function(record){return record.addedNodes&&record.addedNodes.length;})) return;
    pfiBootQueued=true;
    requestAnimationFrame(function(){pfiBootQueued=false;init(document);});
  }).observe(document.body,{childList:true,subtree:true});
})();

